import React, { useEffect, useState } from 'react'

import Axios from 'axios'
import FixtureTemplate from './FixtureTemplate';
import Loader from '../../../../Loader/Loader';
import FixtureTemplateVgLive from '../SingleFixtureTemplates/FixtureTemplateVgLive';

function FixturesLiveNow({type, requestCount}) {

    const [fixtures, setFixtures] = useState();
    const [isLoading, setIsLoading] = useState(true)
    const [show, setShow] = useState(false);

    useEffect(() => {

        console.log(requestCount, "RequestCount FixturesLiveNow")

        async function fetchLiveData() {
            setIsLoading(true)
            try {
                const response = await Axios({
                    "method":"GET",
                    "url":"https://api-football-v1.p.rapidapi.com/v2/fixtures/live",
                    "headers":{
                    "content-type":"application/octet-stream",
                    "x-rapidapi-host":"api-football-v1.p.rapidapi.com",
                    "x-rapidapi-key":"4a924e26e2msh6cbbda7a5553cb0p10cffcjsn999d1a4b9b45",
                    "useQueryString":true
                    },"params":{
                    "timezone":"Europe/London"
                    }
                })
                if (response.data) {
                    //console.log(response.data.api.fixtures)
                    setFixtures(response.data.api.fixtures)
                }
                

            } catch (error) {
                console.log(error)
            }
            setIsLoading(false)

        }
        fetchLiveData()

    }, [requestCount])

    function toggle() {
        if (show) {
            setShow(false);
        } else {
            setShow(true)
        }
    }



    return (
        <div>
            <div className="card card-header bg-lightgrey" onClick={toggle}>
                <div>
                    <small>Live nå <span className="float-right"><i className={`fas fa-chevron-${show ? "down" : "up"}`}></i></span></small>
                </div>
            </div>
            {isLoading && <Loader />}
            {show && (
                <React.Fragment>
                    {fixtures?.map((fixture, index) => {
                        return (
                            <FixtureTemplateVgLive key={index} type={type} fixture={fixture} fixtureId={fixture.fixture_id} />
                        )
                    })}
                </React.Fragment>
            )}

        </div>
    )

}
export default FixturesLiveNow